import './order-style.css';
import 'react-phone-number-input/style.css';
import PhoneInput from "react-phone-number-input";
import {useState} from "react";
import Boy from '../../assets/img/boy.png';
import {InputMask} from "primereact/inputmask";
import {ValidationErrors} from "./ValidationErrors";
import {OrderData} from "./OrderData";
import axios from "axios";
import {toast} from "react-toastify";
import {ModelRules} from "../modal/rules/ModelRules";



export const Order = () =>{
    const [isModalRulesOpen, setIsModalRulesOpen] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [valueDate, setValueDate] = useState<string>('');
    const [value, setValue] = useState<string | undefined>();
    const [name, setName] = useState('');
    const [party, setParty] = useState('');
    const [place, setPlace] = useState('');
    const [isAgree, setAgree] = useState(false);
    const [error, setError] = useState<ValidationErrors>({});

    const [orderData, setOrderData] = useState<OrderData>({
        name: '',
        phone: '',
        party: '',
        place: '',
        date: '',
    });

    const validate = (): boolean => {
        const newErrors: ValidationErrors = {};

        if (!name.trim()) newErrors.name = 'Вы не ввели имя!';
        if (!value) newErrors.phone = 'Вы не ввели номер телефона';
        if (!party.trim()) newErrors.party = 'Выберите вечеринку';
        if (!place.trim()) newErrors.place = 'Укажите место проведения';
        if (!valueDate.trim()) newErrors.date = 'Укажите дату проведения';
        if (!isAgree) newErrors.agree = 'Необходимо согласие на обработку данных';

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const submitForm = async () => {
        if (!validate()) return;
        setIsSending(true);
        try {
            const dataToSend: OrderData = {
                name,
                phone: value || '',
                party,
                place,
                date: valueDate,
            };

            const response = await axios.post(
                'https://wow-holiday-server-miha823.amvera.io/api/order-party',
                dataToSend
            );

            if (response.data.success) {
                toast.success('Заявка успешно отправлена!', { position: 'bottom-right' });
                resetForm();
            } else {
                const serverError = response.data.message || 'Ошибка на сервере';
                toast.error('Ошибка отправки: ' + serverError, { position: 'bottom-right' });
            }
        } catch (err) {
            console.error('Ошибка отправки:', err);
            toast.error('Не удалось отправить заявку. Проверьте соединение.', { position: 'bottom-right' });
        } finally {
            setIsSending(false);
        }
    };

    const resetForm = () => {
        setName('');
        setValue('');
        setParty('');
        setPlace('');
        setValueDate('');
        setAgree(false);
        setOrderData({ name: '', phone: '', party: '', place: '', date: '' });
        setError({});
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value);
    const handlePartyChange = (e: React.ChangeEvent<HTMLSelectElement>) => setParty(e.target.value);
    const handlePlaceChange = (e: React.ChangeEvent<HTMLInputElement>) => setPlace(e.target.value);
    const handleDateChange = (e: any) => setValueDate(e.value as string);
    const handleAgreeChange = (e: React.ChangeEvent<HTMLInputElement>) => setAgree(e.target.checked);

    const openModalRules = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsModalRulesOpen(true);
    }

    const closeModalRules = () => {
        setIsModalRulesOpen(false);
    }

    return(
        <section className={'Order'} id={'order'}>
            <div className={'container'}>
                <h1 className={'section__title'}>Оставить заявку</h1>
                <div className={'form-wrap'}>
                    <img src={Boy} alt={'Boy'} className={'order-img'}/>
                    <form id="partyOrderForm" className={'order-form'} onSubmit={(e) => {
                        e.preventDefault();
                        submitForm();
                    }}>
                        <div className="form-group">
                            <label htmlFor="childName">Введите имя</label>
                            <input  className={'form__field'}
                                    type="text"
                                    id="childName"
                                    name="childName"
                                    placeholder="Например, Максим" onChange={handleNameChange}/>
                            {error.name && <span className="error-form">{error.name}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Введите номер телефона</label>
                               <PhoneInput className={'form__field'} international
                                        defaultCountry="RU"
                                        vvalue={value}
                                        onChange={setValue} />
                            {error.phone && <span className="error-form">{error.phone}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="location">Место проведения</label>
                            <input className={'form__field'}
                                   type="text"
                                   id="location"
                                   name="location"
                                   placeholder="Адрес или название площадки"
                                   value={place}
                                   onChange={handlePlaceChange}/>
                            {error.place && <span className="error-form">{error.place}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="eventType">Выбор вечеринки</label>
                            <select className={'form__field'} id="eventType" name="eventType"  value={party}
                                    onChange={handlePartyChange} >
                            <option value="">Выберите вечеринку</option>
                            <option value="Хай Барби!">Хай Барби!</option>
                            <option value="Бэтмен">Бэтмен</option>
                            <option value="Супер Кот">Супер Кот</option>
                            <option value="Челлендж пати">Челлендж пати</option>
                            <option value="Дино вечеринка">Дино вечеринка</option>
                            <option value="Морозное волшебство">Морозное волшебство</option>
                            <option value="Моя ферма">Моя ферма</option>
                            <option value="Шоу гигантских подушек">Шоу гигантских подушек</option>
                            <option value="Гринчеринка">Гринчеринка</option>
                            <option value="Неоновое приключение на луну">Неоновое приключение на луну</option>
                            <option value="Волшебный мир единорогов">Волшебный мир единорогов</option>
                            <option value="Мейвис">Мейвис</option>
                            <option value="Пижамная вечеринка">Пижамная вечеринка</option>
                            <option value="Палеонтолог">Палеонтолог</option>
                            <option value="Паутина веселья">Паутина веселья</option>
                            <option value="Пиратская вечеринка">Пиратская вечеринка</option>
                            <option value="Сумасшедший ученый и лабуба">Сумасшедший ученый и лабуба</option>
                            <option value="Экспресс-поздравление от Лабубу">Экспресс-поздравление от Лабубу</option>
                            <option value="Та самая игра">Та самая игра</option>
                            <option value="Геймеры">Геймеры</option>
                            <option value="Футбольная вечеринка">Футбольная вечеринка</option>
                            <option value="Вечеринки для праздников">Вечеринки для праздников</option>
                        </select>
                            {error.party && <span className="error-form">{error.party}</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="date">Дата проведения</label>
                    <InputMask
                        className={'form__field'}
                        mask="99.99.9999"
                        slotChar="ДД.ММ.ГГГГ"
                        placeholder={'12.12.2025'}
                        value={valueDate}
                        onChange={handleDateChange}
                    />
                    {error.date && <span className="error-form">{error.date}</span>}
                </div>

                <div className="checkbox-group">
                    <input type="checkbox" id="privacy" name="privacy" checked={isAgree}
                           onChange={handleAgreeChange}/>
                    <label htmlFor="privacy">Я согласен на обработку <a className={'rules-link'} onClick={openModalRules}>персональных данных</a></label>
                    <div>{error.agree && <span className="error-form">{error.agree}</span>}</div>
                </div>

                <button type="submit" className={`submit-btn ${isSending ? 'btn-disabled' : ''}`}
                        disabled={isSending}>
                    {isSending ? 'Отправляется...' : 'Отправить'}</button>
            </form>
        </div>
    </div>
            <ModelRules isOpen={isModalRulesOpen} onClose={closeModalRules} />
</section>

)
}